import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { SignIn } from 'phosphor-react';
import { useRouter } from 'next/router';

import { BlobWithIcon } from '../Blob';
import { media } from '../../../styles/base';

const useStyles = makeStyles(
  createStyles({
    emptyBox: {
      alignItems: 'center',
      background: '#ffffff',
      border: '1px solid #e2e2e2',
      borderRadius: 20,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      margin: '20px auto',
      padding: 48,
      width: '90%',
      [media.mobile]: {
        padding: '48px 32px',
      },
    },
    heading: {
      color: '#2D2332',
      fontFamily: 'Poppins',
      fontSize: 24,
      fontWeight: 700,
    },
    subtext: {
      color: '#323232',
      fontFamily: 'Poppins',
      fontSize: 18,
      padding: 32,
    },
    button: {
      background: '#195a50',
      borderRadius: 10,
      color: '#ffffff',
      fontFamily: 'Poppins',
      fontSize: 18,
      height: 41,
      padding: '8px 16px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#229281',
      },
    },
  }),
);

interface Props {
  subtext?: string;
  icon: React.ReactNode;
}
function SignupAlertCard(props: Props) {
  const classes = useStyles();
  const router = useRouter();

  const handleClick = () => {
    const { asPath } = router;
    const usePath = asPath.includes('/search') ? '/search' : asPath;
    router.push({
      pathname: '/signup/onboarding',
      query: {
        stage: 'intro',
        question: 'cover',
        signupPath: `${encodeURI(usePath)}`,
      },
    });
  };

  return (
    <div className={classes.emptyBox}>
      <h2 className={classes.heading}>You’re almost there!</h2>
      <BlobWithIcon icon={props.icon} />
      <p className={classes.subtext}>{props.subtext}</p>
      <Button onClick={handleClick} className={classes.button}>
        Create an account
      </Button>
    </div>
  );
}

SignupAlertCard.defaultProps = {
  subtext: `Sign up for access to millions of listings, property data, market trends, and more.`,
  icon: <SignIn size={24} color="#737373" weight="regular" />,
};

export default SignupAlertCard;
